import { render, staticRenderFns } from "./refractiveAssessment.vue?vue&type=template&id=645f88ea&scoped=true&"
import script from "./refractiveAssessment.vue?vue&type=script&lang=js&"
export * from "./refractiveAssessment.vue?vue&type=script&lang=js&"
import style0 from "./refractiveAssessment.vue?vue&type=style&index=0&id=645f88ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f88ea",
  null
  
)

export default component.exports